// `wait` milliseconds.
export const debounce = (func, wait) => {
  let timeout

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

const toRad = num => (num * Math.PI) / 180

/* eslint max-params: [1, 4] */
export const distance = (lon1, lat1, lon2, lat2) => {
  let distInMiles = ''
  try {
    const R = 6371 // Radius of the earth in km
    const dLat = toRad(lat2 - lat1) // Javascript functions in radians
    const dLon = toRad(lon2 - lon1)
    const a = (Math.sin(dLat / 2) * Math.sin(dLat / 2)) + (Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2))
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const d = R * c // Distance in km
    const distInKM = d
    distInMiles = distInKM * 1000 * 0.00062137 // Distance in Mile
    // let distInYard = distInKM * 1093.6   // Distance in Yard

    return distInMiles.toFixed(2)
  } catch (e) {
    console.log(e.message)

    return distInMiles
  }
}
